export default function urlFixer(url) {
  var protocol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "http";

  if (!url) {
    return "";
  }
  if (url.match(/^[a-zA-Z]+:\/\//)) {
    return url;
  } else {
    return protocol + "://" + url;
  }
}